module.exports = __webpack_public_path__ + "img/hall_2.e9bbece6.jpg";